import {
  SET_QUESTION_RESPONSES, ADD_QUESTION_RESPONSE, UPDATE_QUESTION_RESPONSE, UNSET_QUESTION_RESPONSE
} from './actionTypes';
import update from "immutability-helper";

const initialState = {};

export const reducer = (state = initialState, action) => {
  switch (action.type) {

    case SET_QUESTION_RESPONSES:
      return action.questionResponses;

    case ADD_QUESTION_RESPONSE: {
      return {
        ...state,
        [action.questionResponse.question]: action.questionResponse,
      };
    }
      
    case UPDATE_QUESTION_RESPONSE: {
      return {
        ...state,
        [action.questionResponse.question]: action.questionResponse,
      };
    }

    case UNSET_QUESTION_RESPONSE: {
      return update(state, {
        $unset: [action.question]
      });
    }

    default:
      return state;
  }
};